export const history = {
    naviate: null,
    location: null
};